<template>
  <div id="app">
    <canvas id="curveBackground" width="1000" height="1000" />
    <div id="nav">
      <TitleCCM :enable-trans="true"/>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">Acerca de</router-link>
    </div>
    <router-view style="padding: 15px;"/>
  </div>
</template>

<script>
// @ is an alias to /src
import TitleCCM from '@/components/TitleCCM.vue'
import 'bulma/css/bulma.css'

export default {
  name: 'home',
  components: {
    TitleCCM
  },
  methods:{
    drawCCurve(){
      let canvas = document.getElementById('curveBackground');

      let ctx = canvas.getContext('2d');
      let ch = canvas.height;
      let cw = canvas.width;
      let gradient=ctx.createLinearGradient(100,0,canvas.width-100,0);
      gradient.addColorStop(0,'#3e9042');
      gradient.addColorStop(1,'#8ca742');
      ctx.beginPath();
      ctx.moveTo(0, 0);
      //ctx.quadraticCurveTo(ch, 100, cw/2, ch/2);
      ctx.bezierCurveTo(0, cw*0.3, cw-(cw*0.3), 0, cw/2, ch/2);
      ctx.bezierCurveTo(cw/2, ch/2, cw*0.3, ch, cw, ch);
      ctx.lineTo(cw, 0);   // these two lines
      ctx.lineTo(0, 0);
      ctx.strokeStyle=gradient;
      ctx.fillStyle=gradient;
      ctx.fill();
      canvas.style.opacity = 1;
      canvas.style.top = "-2%";
      canvas.style.right = "0%";
      canvas.style.transform = "rotate(0deg)";
    }
  },
  mounted(){
    this.drawCCurve()
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#curveBackground{
  position: absolute;
  z-index: -10;
  width: 45%;
  height: 27%;
  top: -40%;
  right: -30%;
  transition: 1s ease;
  transform: rotate(-65deg);
  opacity: 0;
}

#nav {
  padding: 30px;
  position: relative;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
